export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_LIST_CAREGIVER: 'GET_LIST_CAREGIVER',
  GET_LIST_LEADER: 'GET_LIST_LEADER',
  GET_LIST_STAFF: 'GET_LIST_STAFF',
}
